module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui dividing header"
  }, [_vm._v("Rating")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui large label"
  }, [_vm._v("\n    Rating the stars:\n    "), _c('div', {
    staticClass: "detail"
  }, [_c('rating', {
    attrs: {
      "ratingId": "ratingDoc",
      "type": _vm.type,
      "customClass": "big",
      "currentRating": _vm.currentRating,
      "maxRating": 5
    },
    on: {
      "update:currentRating": function($event) {
        _vm.currentRating = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui buttons"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.changeIconType('heart')
      }
    }
  }, [_vm._v("Heart Icons")]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.changeIconType('star')
      }
    }
  }, [_vm._v("Stars Icons")])]), _vm._v(" "), _c('div', {
    staticClass: "ui buttons"
  }, [_c('button', {
    staticClass: "ui left attached icon button",
    on: {
      "click": _vm.decreaseRating
    }
  }, [_c('i', {
    staticClass: "left arrow icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui disabled button"
  }, [_vm._v("\n      Current Rate: " + _vm._s(_vm.currentRating) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "ui right attached icon button",
    on: {
      "click": _vm.increaseRating
    }
  }, [_c('i', {
    staticClass: "right arrow icon"
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Usage")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Props")]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Rating component,\n    "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/rating.html"
    }
  }, [_vm._v(" you can see all documentation here")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment code"
  }, [_c('pre', [_vm._v("\n        import { Rating } from 'semvue';\n\n        export default {\n            components: {\n                Rating,\n            },\n        }\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment code"
  }, [_c('pre', [_vm._v("\n      <rating ratingId=\"ratingDoc\" :type=\"type\" customClass=\"big\" :currentRating.sync=\"currentRating\" :maxRating=\"5\"></rating>\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ui definition table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("ratingId")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Is a div id for rating")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("currentRating")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Used to control current rating (also used to define initial rating)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("maxRating")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("The max rating icons of component")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("String empty (standard rating)")]), _vm._v(" "), _c('td', [_vm._v("The type of rating.\n          "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/rating.html"
    }
  }, [_vm._v(" You can see all types here")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("curstomClass")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("String empty")]), _vm._v(" "), _c('td', [_vm._v("Used to put any aditional class inside rating div "), _c('br'), _vm._v("\n          e.g. class=\"ui customClass rating\"\n        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("Object empty")]), _vm._v(" "), _c('td', [_vm._v("Overrides component options."), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/rating.html"
    }
  }, [_vm._v(" You can see all options here")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9526b1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RatingDoc.vue
// module id = 155
// module chunks = 1